import { render, staticRenderFns } from "./createAppointment.vue?vue&type=template&id=34cdfbab&"
import script from "./createAppointment.vue?vue&type=script&lang=js&"
export * from "./createAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports